import { columnsQuery } from 'app/common/lib/react/gridUtils';

const cssStyles = (isOpen, pinImageWidthMax) => {
  // including all Category Nav CSS & Search Box CSS
  let styles = `
.UnauthHeader__headerContainer {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.UnauthHeader__discoverText {
  display: block;
}
.UnauthHeader__rightContentContainer {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
}

.UnauthHeader__hoverUnderline:hover {
  text-decoration: underline;
}
`;

  if (isOpen) {
    // Hide tagline at <= 4 columns
    styles += columnsQuery(
      pinImageWidthMax,
      0,
      4,
      `
.UnauthHeader__discoverText {
  display: none;
}
`,
    );
  }
  return styles;
};

export default cssStyles;
